/**
 * Client-side mirrors of the SQL scoring functions, for showing a total
 * as someone types. The database remains the authority — anything that
 * matters is recomputed server side on submit.
 */

/** Unrounded. Everything downstream should work from this. */
export const courseHandicapExact = (index, slope, rating, par) =>
  index * (slope / 113) + (rating - par);

/** Rounded — the number that goes on the card. */
export const courseHandicap = (index, slope, rating, par) =>
  Math.round(courseHandicapExact(index, slope, rating, par));

/**
 * Allowance applied to the exact course handicap, rounded once.
 *
 * Taking a percentage of an already-rounded number rounds twice and is
 * a shot out either way for a third of players: 21.4 off a 128 slope is
 * exactly 24.64, and 95% of that is 23, not the 24 you get from 95% of 25.
 */
export const playingHandicap = (index, slope, rating, par, allowance) =>
  Math.round(courseHandicapExact(index, slope, rating, par) * (allowance / 100));

/** Shots given on a hole. Handles plus handicaps, which give shots back. */
export function shotsReceived(playing, strokeIndex) {
  if (playing >= 0) {
    return Math.floor(playing / 18) + (strokeIndex <= playing % 18 ? 1 : 0);
  }
  return strokeIndex > 18 + playing ? -1 : 0;
}

/** Stableford. Null strokes (not holed out) score nothing. */
export const points = (strokes, par, shots) =>
  strokes == null ? 0 : Math.max(0, 2 + (par + shots) - strokes);

/** Circle under par, square over — real scorecard notation. */
export function tone(strokes, par) {
  if (strokes == null) return "nr";
  const d = strokes - par;
  if (d <= -3) return "albatross";
  if (d === -2) return "eagle";
  if (d === -1) return "birdie";
  if (d === 0) return "par";
  if (d === 1) return "bogey";
  return "double";
}

export const ord = (n) => {
  const s = ["th", "st", "nd", "rd"], v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};
